export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./photo-plug.vue?vue&type=template&id=0e84fcbf&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/photo-plug/photo-plug.vue?vue&type=template&id=0e84fcbf&
// module id = 1488
// module chunks = 0